import useSWR from 'swr';
import { SubscriptionLimitsDataType } from '../../containers/subscription/SubscriptionController';
import { customSWRConfig } from '../../model/types';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useSubscriptionLimits(config: customSWRConfig = {}) {
    const keys = useSWRCacheKeys('/subscriptions/current/limits');
    return useSWR<SubscriptionLimitsDataType>(keys, { ...config });
}
